import { render, staticRenderFns } from "./AddprouctShop.vue?vue&type=template&id=34966bfc&scoped=true&"
import script from "./AddprouctShop.vue?vue&type=script&lang=js&"
export * from "./AddprouctShop.vue?vue&type=script&lang=js&"
import style0 from "./AddprouctShop.vue?vue&type=style&index=0&id=34966bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34966bfc",
  null
  
)

export default component.exports